'use client'
import { cn } from '@/lib/utils'
import { text12px, text16px, text32px, text36px } from '@/app/utils'
import Image from 'next/image'
import React from 'react'
import { Button } from '@/registry/default/ui/button'
import { useRouter } from 'next/navigation'
import { useSession } from 'next-auth/react'

export default function Bot() {
  const { status } = useSession()
  const router = useRouter()

  return (
    <div className={cn('w-full bg-[#F1F2FE]')}>
      <div
        className={cn(
          'container w-full flex flex-row items-center justify-center py-12 space-x-10'
        )}
      >
        <div
          className={cn('flex flex-row items-center justify-center w-[50%]')}
        >
          <div
            className={cn(
              'bg-white space-y-5 p-5 min-w-[23rem] max-w-[23rem] rounded-[6px]'
            )}
          >
            <div className={cn(text12px, 'text-[#444BD3] font-bold')}>
              真实电话录音
            </div>
            <div className={cn(text36px, 'text-[#1D1D1D] font-bold')}>
              营销平板电脑
            </div>
            <div className={cn(text12px, 'text-[#1211278F]')}>
              我们覆盖到城市几乎遍布中国所有大区，南北方言地区都有涉及，并在持续快速提升。
            </div>
            <div className={cn('flex flex-row items-center justify-between')}>
              <Image
                alt={'design'}
                src={'/home/home-play.png'}
                width={32}
                height={32}
                className={cn('object-cover')}
              />
              <Image
                alt={'design'}
                src={'/home/home-voice.png'}
                width={212}
                height={16}
                className={cn('object-cover')}
              />
              <div className={cn(text12px, 'text-[#1211278F]')}>2:45</div>
            </div>
            <div
              className={cn(
                text12px,
                'w-full bg-[#F1F2FE] text-center text-[#1211278F] py-2 rounded-[6px]'
              )}
            >
              点击 “播放” 按钮听效果
            </div>
          </div>
          <Image
            alt={'design'}
            src={'/home/phone.svg'}
            width={360}
            height={740}
            className={cn('object-cover')}
          />
        </div>
        <div className={cn('w-[50%] p-10')}>
          <div className={cn('w-[400px] space-y-5')}>
            <div>
              <div className={cn(text32px, 'font-bold')}>即专业又耐心</div>
              <div className={cn(text32px, 'font-bold')}>
                和人一样好用的 AI 电话员工
              </div>
            </div>
            <div className={cn(text12px, 'text-[#7A7A86]')}>
              在拨业务日常调整频繁，一个新业务通常要经历十几次调整后才能趋于稳定，能够快捷的调整话术非常关键。我们提供
              AI
              电话员工话术维护功能，让你轻松应对业务调整，快速响应，实时变更，无培训与纠错成本；
            </div>
            <Button
              className={cn(
                text16px,
                'bg-[#444BD3] w-[124px] h-[52px] rounded-[6px]'
              )}
              onClick={() => {
                status === 'authenticated'
                  ? router.push(`/dashboard`)
                  : router.push('/register')
              }}
            >
              申请试用
            </Button>
          </div>
          <div className={cn('grid grid-cols-3 gap-5 mt-10')}>
            <div className={cn('space-y-3')}>
              <div
                className={cn(
                  text12px,
                  'text-[#F25722] bg-[#FFF4E6] rounded-full px-2 py-1 inline-block'
                )}
              >
                低成本
              </div>
              <div className={cn(text12px, 'font-bold text-[#121127]')}>
                0 培训，超低运营成本
              </div>
              <div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  无需培训，AI 严格依从话术中的对话流程进行沟通；
                </div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  超低运营成本，无需运营人员参与。
                </div>
              </div>
              <div
                className={cn(
                  'flex flex-row items-center justify-start space-x-3'
                )}
              >
                <div className={cn(text12px, 'text-[#444BD3]')}>
                  查看产品操作文档
                </div>
                <Image
                  alt={'design'}
                  src={'/home/home-arrow.png'}
                  width={18}
                  height={18}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('space-y-3')}>
              <div
                className={cn(
                  text12px,
                  'text-[#EC4899] bg-[#FCE7F3] rounded-full px-2 py-1 inline-block'
                )}
              >
                快速响应
              </div>
              <div className={cn(text12px, 'font-bold text-[#121127]')}>
                实时调整，即刻生效超低运营成本
              </div>
              <div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  面对业务变化实时调整，随时启停拨打任务；
                </div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  话术修改即刻生效，让你的业务更加灵活。
                </div>
              </div>
              <div
                className={cn(
                  'flex flex-row items-center justify-start space-x-3'
                )}
              >
                <div className={cn(text12px, 'text-[#444BD3]')}>
                  查看产品操作文档
                </div>
                <Image
                  alt={'design'}
                  src={'/home/home-arrow.png'}
                  width={18}
                  height={18}
                  className={cn('object-cover')}
                />
              </div>
            </div>
            <div className={cn('space-y-3')}>
              <div
                className={cn(
                  text12px,
                  'text-[#46A9FF] bg-[#C6E4FE] rounded-full px-2 py-1 inline-block'
                )}
              >
                零投诉
              </div>
              <div className={cn(text12px, 'font-bold text-[#121127]')}>
                情绪稳定，依从指令，几乎零投诉
              </div>
              <div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  面对客户刁难情绪稳定；
                </div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  依从话术设计者的指令，提供标准对话能力，避免 “随意” 发挥；
                </div>
                <div className={cn(text12px, 'text-[#7A7A86]')}>
                  基本达到 “零投诉”，保证业务安全。
                </div>
              </div>
              <div
                className={cn(
                  'flex flex-row items-center justify-start space-x-3'
                )}
              >
                <div className={cn(text12px, 'text-[#444BD3]')}>
                  查看产品操作文档
                </div>
                <Image
                  alt={'design'}
                  src={'/home/home-arrow.png'}
                  width={18}
                  height={18}
                  className={cn('object-cover')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
